<template>
  <div class="flex items-center mb-4 ml-2 mt-2 ">
    <div class="mr-4" v-for="(filter, index) in filters" :key="index">
      <base-button
        size="sm"
        icon
        type="primary"
        class="flex rounded-xl px-4"
        @click="showSwal('primary')"
      >
        <span>
          <feather-icon :icon="filter.icon" svgClasses="w-4 h-4 font-normal " />
        </span>
        <span class="btn-inner--text font-normal cust-fs10">{{
          filter.text
        }}</span>
      </base-button>
      <b-popover
        target="popover-button-variant-primary"
        variant="info"
        triggers="focus"
        placement="top"
        class="bg-primary text-white text-center"
      >
        <p class="text-xs font-bold text-center">Work in Progress</p>
        <p class="text-xs font-medium text-center">
          We are working to offer you the best experience
        </p>
      </b-popover>
    </div>
    <!-- <b-button
      variant="info"
      id="popover-button-variant-primary"
      href="#"
      tabindex="0"
      >Info popover</b-button
    >
    <b-popover
      target="popover-button-variant-primary"
      variant="info"
      triggers="focus"
      placement="top"
    >
      This is a very beautiful popover, show some love.
    </b-popover> -->
  </div>
</template>

<script>
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
export default {
  data() {
    return {
      filters: [
        {
          icon: "ImageIcon",
          text: "Image Post"
        },
        {
          icon: "VideoIcon",
          text: "Video Post"
        },
        {
          icon: "MicIcon",
          text: "Podcast"
        },
        {
          icon: "CoffeeIcon",
          text: "Discussion"
        }
      ]
    };
  },
  methods: {
    showSwal(type) {
      if (type === "primary") {
        swal.fire({
          title: `Work in Progress`,
          text: "We are working to offer you the best experience",
          // buttonsStyling: false,
          showCancelButton: false,
          cancelButtonColor: "",
          confirmButtonClass: "btn btn-primary bg-primary",
          confirmButtonText: "OK",
          cancelButtonText: "No",
          icon: "info"
        });
      }
    }
  }
};
</script>
